import { BellIcon } from 'lucide-react'

import { ScheduledAlertsCard } from '@/pages/client-portal/ui/cards/scheduled-alerts-card/scheduled-alerts-card'
import { ContentSectionHeader } from '@/pages/client-portal/ui/content-section-header/content-section-header'

import { useClientPortalInternalSampleStore } from '@/lib/stores/client-portal-internal-sample-store'
import { cn } from '@/lib/utils'

export const OtherCriticalDates = () => {
  const { currentCase } = useClientPortalInternalSampleStore()

  const scheduledAlertsData = currentCase?.alertSchedule

  return (
    <div className={cn('mt-[30px]')}>
      <ContentSectionHeader icon={<BellIcon size={24} />} title="Other Critical Dates" />

      <div className={cn('mt-5')}>
        <div className={cn('lg:max-w-[400px]')}>
          <ScheduledAlertsCard scheduledAlertsData={scheduledAlertsData} />
        </div>
      </div>
    </div>
  )
}
